<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column label="时间段" prop="" align="center">
			<template #default="scope">
				<span>
					{{ scope.row.startHour }}
				</span>
				<span>-</span>
				<span>
					{{ scope.row.endHour }}
				</span>
			</template>
		</el-table-column>
		<el-table-column
			label="洗车费"
			prop="fee"
			align="center"
		></el-table-column>
		<el-table-column
			label="MPV洗车费"
			prop="mpvFee"
			align="center"
		></el-table-column>
		<el-table-column
			label="奖励金额"
			prop="rewardAmount"
			align="center"
		></el-table-column>
		<el-table-column
			label="SUV洗车费"
			prop="suvFee"
			align="center"
		></el-table-column>
		<el-table-column label="操作" align="center">
			<template #default="scope">
				<el-button
					type="primary"
					size="mini"
					@click="handleEdit(scope.row)"
					>修改</el-button
				>
			</template>
		</el-table-column>
	</el-table>
	<addAndEdit
		v-if="data.showAddAndEdit"
		v-model:toggle="data.showAddAndEdit"
		:currentData="data.currentData"
		scene="edit"
	></addAndEdit>
</template>

<script>
import { reactive } from "vue";
import addAndEdit from "./addAndEdit.vue";
export default {
	props: {
		tableData: Array,
	},
	components: {
		addAndEdit,
	},
	setup() {
		const data = reactive({
			showAddAndEdit: false,
			currentData: {},
		});
		const handleEdit = (val) => {
			data.currentData = val;
			data.showAddAndEdit = true;
		};
		return {
			handleEdit,
			data,
		};
	},
};
</script>

<style  scoped>
</style>
